import { render, staticRenderFns } from "./OnsaleHomeFooter.vue?vue&type=template&id=2f644236&scoped=true&"
import script from "./OnsaleHomeFooter.vue?vue&type=script&lang=js&"
export * from "./OnsaleHomeFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f644236",
  null
  
)

export default component.exports